import Explore02 from "./Explore02";
import Home03 from "./Home03";

const routes = [{ path: "/", component: <Home03 /> }];

export default routes;
